module.exports = __webpack_public_path__ + "pythonPostit.svg?65b8a058349ab41c7761f19dd31f02df";